import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=1e74be42&scoped=true&"
import script from "./task-form.vue?vue&type=script&lang=js&"
export * from "./task-form.vue?vue&type=script&lang=js&"
import style0 from "./task-form.vue?vue&type=style&index=0&id=1e74be42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74be42",
  null
  
)

export default component.exports